<template>
  <div class="number-of-sars p-3">
    <h4>Suspicious activity reports in the FinCEN Files</h4>
    <p class="mb-0">The total number of SARs filed each year in the FinCEN Files data.</p>
    <line-chart :data="data" x-axis-tick-format=",.0f" :social-mode="socialMode" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">Source: FinCEN Files</p>
    <p class="mt-2 font-italic">This data is not representative of all SARs received by the U.S. Department of Treasury's Financial Crimes Enforcement Network. It is based on the 2,121 reports in the FinCEN Files data.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'NumberOfSars',
  mixins: [chart],
  data () {
    return {
      data: [
        { value: 263, date: 2017 },
        { value: 420, date: 2016 },
        { value: 411, date: 2015 },
        { value: 429, date: 2014 },
        { value: 277, date: 2013 },
        { value: 190, date: 2012 },
        { value: 101, date: 2011 },
        { value: 7, date: 2010 },
        { value: 6, date: 2009 },
        { value: 8, date: 2008 }
      ]
    }
  }
}
</script>
